import Navbar from './components/Navbar'
import Banner from './components/Banner'
import About from './components/About'
import Products from './components/Products'
import QuoteForm from './components/QuoteForm'
import Blog from './components/Blog'
import Footer from './components/Footer'

function App() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <Banner />
        <About />
        <Products />
        <QuoteForm />
        <Blog />
      </main>
      <Footer />
    </div>
  )
}

export default App
